import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { ExpressTestByRequestDto } from "../models/express-test/express-test-by-request.dto";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExpressTestLaboratoryIndicatorDto } from "../models/express-test/express-test-laboratory-indicator.dto";
import { ExpressTestUpdateIndicatorDto } from "../models/express-test/express-test-update-indicator.dto";

@Injectable()
export class ExpressTestsService extends DataService<ExpressTestByRequestDto, ExpressTestByRequestDto> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'express-test';
    }

    getTestByCustomerObject(customerObjectId: number, date: string = null): Observable<ExpressTestByRequestDto[]> {
        return this.getQuery<ExpressTestByRequestDto[]>(`${this.baseUrl()}/get-by-customer-object-id/${customerObjectId}?date=${date}`);
    }

    getLaboratoryIndicators(examinationTypeId: number = null): Observable<ExpressTestLaboratoryIndicatorDto[]> {
        return this.getQuery<ExpressTestLaboratoryIndicatorDto[]>(`${this.baseUrl()}/laboratory-indicators?examinationTypeId=${examinationTypeId}`);
    }

    updateTestByCustomerObject(customerObjectId: number, date: string, performerUserId: number, request: ExpressTestUpdateIndicatorDto[] = []): Observable<any> {
        return this.patchQuery(`${this.baseUrl()}/by-customer-object-id/${customerObjectId}?date=${date}&performerUserId=${performerUserId}`, request);   
    }
}